import { funnel } from "../../custom_js/get_svg_sort";

export default function refineSorters(sortby, order) {
  document
    .querySelectorAll(`input[type="hidden"][name="sortby"]`)
    .forEach((sortByInput) => {
      sortByInput.value = sortby;
    });
  document
    .querySelectorAll(`input[type="hidden"][name="order"]`)
    .forEach((orderInput) => {
      orderInput.value = order;
    });
  document.querySelectorAll(`.js-sorter`).forEach((sorter) => {
    if (sorter.dataset.for !== sortby) {
      sorter.dataset.for !== sortby;
      sorter.innerHTML = funnel;
    }
  });
}
